// extracted by mini-css-extract-plugin
module.exports = {"signin":"register_signin__x79OY","inner":"register_inner__3EMf5"};